import React, { forwardRef } from 'react';

import { getSizeSkin } from '../../../../lib/skin/getSizeSkin/getSizeSkin';
import { TagGroupSize } from '../../commonTypes';
import { cn } from '../../../../lib/css/className/className';

import './TagPseudoTrigger.css';

const cls = cn('TagPseudoTrigger');

export interface TagPseudoTriggerProps {
    tagGroupSize?: TagGroupSize;
}

/**
 * div, отображающийся над combobox, на всю ширину TagGroup
 *
 * Нужен для позиционирования Popup,
 * чтобы Popup мог отобразиться с направлением вверх и поверх выбранных тэгов
 */
export const TagPseudoTrigger = forwardRef<HTMLDivElement, TagPseudoTriggerProps>(function TagPseudoTrigger(
    { tagGroupSize },
    ref,
) {
    const sizeSkinClass = getSizeSkin(tagGroupSize ?? 'm');

    return <div ref={ref} className={cls({}, [sizeSkinClass])} />;
});
